//#region INTERFACE IAutoOrderExpirationSettings
export interface IAutoOrderExpirationSettings extends Object {
  isAgeLimitEnabled: boolean;
  orderAgeLimitMS: number;
  confirmDelete?: boolean;
}

//#endregion
